<!-- 任务点排名 -->
<template>
  <div>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">质量在线看板</span>
        <a-popover v-if="false" title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间: 创建时间</p>
            <p>描述: 所选时间段内​各团队​或​个人​负责任务点总数和任务数</p>
            <p>排序: 任务点总数正序（默认）</p>
            <p>操作: 点击右上角团队/个人可切换查看视角<cursor /></p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <a-table :pagination="false" :columns="columns" :data-source="data" size="small">
        <span slot="name" slot-scope="record"> <a-avatar :src="record.avatar_url" :size="20" /> {{ record.nickname }}</span>
      </a-table>
    </a-card>

  </div>
</template>
<script>
import { qualityOnlineData } from '@/api/data/quality';

const columns = [
  {
    title: '昵称',
    width: 180,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '新增Case数',
    align: 'center',
    dataIndex: 'testcase',
    customRender: record => {
      return record.add;
    },
    sorter: (a, b) => a.testcase.add - b.testcase.add,
    sortDirections: ['descend']
  },
  // {
  //   title: '更新Case数',
  //   dataIndex: 'testcase',
  //   align: 'center',
  //   key: 'update',
  //   customRender: record => {
  //     return record.update;
  //   },
  //   sorter: (a, b) => a.testcase.update - b.testcase.update,
  //   sortDirections: ['descend']
  // },
  {
    title: '处理任务流程数',
    dataIndex: 'workflow_number',
    align: 'center',
    key: 'workflow_number',
    sorter: (a, b) => a.workflow_number - b.workflow_number,
    sortDirections: ['descend']
  },
  {
    title: '处理任务Point数',
    dataIndex: 'task_point',
    align: 'center',
    key: 'task_point',
    sorter: (a, b) => a.task_point - b.task_point,
    sortDirections: ['descend']
  },
  {
    title: '处理流程时长',
    dataIndex: 'quality_verify_hour',
    key: 'quality_verify_hour',
    sorter: (a, b) => a.quality_verify_time - b.quality_verify_time,
    sortDirections: ['descend']
  },
  {
    title: '平均每taskpoint处理时长',
    dataIndex: 'quality_verify_per_point',
    key: 'quality_verify_per_point',
    sorter: (a, b) => a.quality_verify_per_point - b.quality_verify_per_point,
    sortDirections: ['descend']
  },
  {
    title: '提交代码次数',
    dataIndex: 'commits',
    key: 'commit_count',
    align: 'center',
    customRender: record => {
      return record.count;
    },
    sorter: (a, b) => a.commits.count - b.commits.count,
    sortDirections: ['descend']
  },
  {
    title: '提交代码行数',
    dataIndex: 'commits',
    align: 'center',
    key: 'commit_line_count',
    customRender: record => {
      return record.total;
    },
    sorter: (a, b) => a.commits.total - b.commits.total,
    sortDirections: ['descend']
  }
];

export default {
  components: {},
  props: {
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns,
      data: [],
      loading: true
    };
  },
  watch: {
    filterForm() {
      this.getQualityOnlineData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  methods: {
    getQualityOnlineData() {
      this.loading = true;
      qualityOnlineData(this.filterForm).then(res => {
        this.loading = false;
        this.data = res.data.items;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
